module.exports = __webpack_public_path__ + "static/media/video6.7bf53021.jpg";